<app-header-simple
  [hidden]="loading"
  [title]="'carteira'"
  [showBtnBack]="true"
></app-header-simple>

<ion-content [hidden]=" loading">
  <ion-refresher slot="fixed" (ionRefresh)="onRefreshPage($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <div class="content">
    <ion-header>
      <div class="header-balance">
        <app-credits
          [user]="user"
          [updateCredits]="updateCredits"
          [showBlocked]="true"
        >
        </app-credits>
        <div class="add">
          <ion-button (click)="onClickAdd()" color="secondary">
            Adicionar</ion-button
          >
          <ion-button (click)="onClickWithdraw()" color="dark">
            Retirar</ion-button
          >
        </div>
      </div>
    </ion-header>

    <div class="main">
      <ion-segment [(ngModel)]="selectTabs" value="balance">
        <ion-segment-button value="balance">
          <ion-label>Seus Créditos</ion-label>
        </ion-segment-button>
        <ion-segment-button value="indicated">
          <ion-label>Indicados</ion-label>
        </ion-segment-button>
      </ion-segment>
      <div class="balance" *ngIf="selectTabs === 'balance'">
        <div class="credits">
          <div class="credit-item">
            <ion-img [src]="'assets/icon/money.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.statements?.totalCashbackAmount}}
              <span>créditos de Recompensa.</span>
            </h3>
          </div>
          <div class="credit-item">
            <ion-img [src]="'assets/icon/account.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.statements?.indicatorCredits}}
              <span>créditos de seus Indicados.</span>
            </h3>
          </div>
          <div
            *ngIf="!user?.isPrime"
            class="credit-item credit-item-last"
            [ngClass]="{ 'credit-item-prime': user?.isPrime }"
          >
            <ion-img [src]="'assets/icon/network.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.statements?.indicatorCreditsOnHold}}
              <span>créditos a receber de sua Rede Prime.</span>
            </h3>
          </div>
        </div>
        <ion-button
          (click)="onClickPrime()"
          color="secondary"
          [hidden]="user?.isPrime"
          >{{ user?.isPrime ? 'Cancelar Plano' : 'Torne-se Prime' }}</ion-button
        >
      </div>
      <div class="indicated" *ngIf="selectTabs === 'indicated'">
        <div class="credits">
          <div class="credit-item">
            <ion-img [src]="'assets/icon/user.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.indicateds?.indicated}} <span>amigos Indicados.</span>
            </h3>
          </div>
          <div class="credit-item">
            <ion-img [src]="'assets/icon/business.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.indicateds?.companyIndicated}}
              <span>negócios Indicados.</span>
            </h3>
          </div>
          <div
            class="credit-item"
            [ngClass]="{ 'credit-item-prime': user?.isPrime }"
          >
            <ion-img [src]="'assets/icon/network.svg'" [alt]="'...'"></ion-img>
            <h3>
              {{user?.indicateds?.primeNetworkMembers}}
              <span>usuários em sua Rede Prime.</span>
            </h3>
          </div>
          <ion-button (click)="onClickDetails()" color="dark"
            >Detalhes</ion-button
          >
        </div>
        <ion-button (click)="onClickPrime()" color="secondary"
          >{{ user?.isPrime ? 'Cancelar Plano' : 'Torne-se Prime' }}</ion-button
        >
      </div>
    </div>
  </div>
</ion-content>
